<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">
    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <app-autocomplete
      label="Actividad económica"
      searchType="remote"
      [remoteSearchFn]="_listService.searchEconomicActivity.bind(_listService)"
      [defaultValue]="defaultData?.econmicActivity"
      [findByIdFn]="_listService.findByIdEconomicActivity.bind(_listService)"
      labelKey="name"
      valueKey="id"
      (valueChange)="form.patchValue({ econmicActivity: $event })"
    >
    </app-autocomplete>

    @for (config of dataInputs(); track $index) {
        <app-input
            class="w-full"
            [config]="config"
            [timeoutSeconds]="0.6"
            (submitValue)="handleValue($event)"
        ></app-input>
    }

    <app-selected class="w-full"
        [config]="dataSelected().at(1)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <app-autocomplete
      label="¿Cuál es tu profesión?"
      searchType="local"
      [items]="codpros"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.codpro"
      (valueChange)="form.patchValue({ codpro: $event })">
    </app-autocomplete>

    <app-selected class="w-full"
        [config]="dataSelected().at(2)"
        (selectValue)="handleValue($event)"
    ></app-selected>
    
    <!-- {{ form.value | json }} -->

</form>
